import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import {Repository} from 'typeorm';
import { TrimsDTO } from './dto/trims.dto';
import { Trims } from './trims.entity';
import { TrimsAdapter } from './dto/trims.adapter'
import { ErrorResponse } from '@gtpl/shared-models/common-models';
import {TrimsRequest} from './dto/trims.request';
import { AllTrimsResponse, TrimsResponse ,TrimsDropDownDto, TrimsDto} from '@gtpl/shared-models/masters';
import { CommonResponse } from '@gtpl/shared-models/production-management';

@Injectable()
export class TrimsService {
    constructor(
        @InjectRepository(Trims) private trimsRepository: Repository<Trims>,
        private TrimsAdapter: TrimsAdapter,
      ) { }

      async createTrims(trimsDTO:TrimsDTO, isUpdate: boolean,request:Request): Promise<TrimsResponse> {
        try {
        
        if (!isUpdate) {
            const trimsEntity = await this.getTrims(trimsDTO.trimName);
          if (trimsEntity) {
            throw new TrimsResponse(false,11104, 'trims already exists');
          }
        }
        else{
            const trimsEntity = await this.getTrims(trimsDTO.trimName);
            if (trimsEntity) {
                if(trimsEntity.trimsId!=trimsDTO.trimsId){
                    throw new TrimsResponse(false,11104, 'trims  already exists');
                }
            }
        }
        const convertedtrimsEntity:Trims = this.TrimsAdapter.convertDtoToEntity(trimsDTO,isUpdate);
        const savedtrimsEntity: Trims = await this.trimsRepository.save(convertedtrimsEntity);
        const savedtrimsDTO: TrimsDTO = this.TrimsAdapter.convertEntityToDto(savedtrimsEntity);
       
         if (savedtrimsDTO) {
          const response = new TrimsResponse(true,isUpdate ? 11100 : 11101,isUpdate? 'Trims date Updated Successfully':'Trims Created Successfully',savedtrimsDTO);
          return response;
        } else {
          throw new TrimsResponse(false,11106,'Trims saved but issue while transforming into DTO');
        }
      }
      catch (error) {
        return error;
      }
    }

    /**
     * gets all Trims details  
     * @returns all the Trims details .
     */
    // @LogActions({ isAsync: true })
    async getAllTrims(): Promise<AllTrimsResponse> {  
        try {
            const trimsDTO: TrimsDTO[] = [];
           
            const trimsEntities: Trims[] = await this.trimsRepository.find({
                order: { trimName: "ASC" },
            });
            
            if (trimsEntities.length>0) {
                trimsEntities.forEach(TrimsEntity => {
                const convertedtrimsDTO:TrimsDTO = this.TrimsAdapter.convertEntityToDto(TrimsEntity);
                trimsDTO.push(convertedtrimsDTO);
                });
                const response = new AllTrimsResponse(true, 11208, "Trims retrieved successfully", trimsDTO);
                return response;
            } else {
                //   console.log('yest')
                throw new TrimsResponse(false,99998, 'No Records Found');
            }
        } catch (err) {
            return err;
        }
    }

    async getTrims(trimName: string): Promise<Trims> {
        
            const response = await this.trimsRepository.findOne({
            where: {trimName: trimName},
            });
            // console.log(response);
            if (response) {
            return response;
            } else {
            return null;
            }
        }

    /**
     * It deactivates value    Trims   
     * @param itemReq      Trims as string
     * @returns true or false
     */
    // @LogActions({isAsync: true})
    async activateOrDeactivateTrims(trimsReq: TrimsRequest): Promise<TrimsResponse> {
        try {
            const trimsExists = await this.getTrimsById(trimsReq.trimsId);
            if (trimsExists) {
                if (trimsReq.versionFlag !== trimsExists.versionFlag) {
                    throw new TrimsResponse(false,10113, 'Someone updated the current Trims information.Refresh and try again');
                } else {
                    
                        const trimsStatus =  await this.trimsRepository.update(
                            { trimsId: trimsReq.trimsId },
                            { isActive: trimsReq.isActive,updatedUser: trimsReq.updatedUser });
                       
                        if (trimsExists.isActive) {
                            if (trimsStatus.affected) {
                                const trimsResponse: TrimsResponse = new TrimsResponse(true, 10115, 'Trims is de-activated successfully');
                                return trimsResponse;
                            } else {
                                throw new TrimsResponse(false,10111, 'Trims is already deactivated');
                            }
                        } else {
                            if (trimsStatus.affected) {
                                const trimsResponse: TrimsResponse = new TrimsResponse(true, 10114, 'Trims is activated successfully');
                                return trimsResponse;
                            } else {
                                throw new TrimsResponse(false,10112, 'Trims is already  activated');
                            }
                        }
                    // }
                }
            } else {
                throw new TrimsResponse(false,99998, 'No Records Found');
            }
        } catch (err) {
            return err;
        }
    }

    async getTrimsById(trimsId: number): Promise<Trims> {
    //  console.log(employeeId);
        const response = await this.trimsRepository.findOne({
        where: {trimsId: trimsId},
        });
        
        if (response) {
        return response;
        } else {
        return null;
        }
    }

    async getAllTrimsDropDown(): Promise<CommonResponse> {
        try {
            const trimsDto: TrimsDropDownDto[] = [];
            // retrieves all plants
            const trimsEntities: Trims[] = await this.trimsRepository.find({
                order: { trimName: "DESC" }, where: { isActive: true }
            });
            if (trimsEntities.length > 0) {
                trimsEntities.forEach(trimsEntity => {
                    const convertedtrimsDto = new TrimsDropDownDto(trimsEntity.trimsId, trimsEntity.trimName);
                    trimsDto.push(convertedtrimsDto);
                });
                const response = new CommonResponse(true, 11208, "Trims retrieved successfully", trimsDto);
                return response;
            } else {
                throw new TrimsResponse(false,99998, 'No Records Found');
            }
        } catch (err) {
            return err;
        }
    }


    async getTrimsInfoById(trimsId: number):Promise<CommonResponse> {
        try {
            const Response = await this.trimsRepository.findOne({
                where: { trimsId: trimsId },
            });

            if (Response) {
                return new CommonResponse(true, 11111, 'trim Info Retrieved Successfully', Response);
            } else {
                return new CommonResponse(false, 99999, 'Not Found');
            }
        } catch (error) {
            return error;
        }
    }
   

}
